export default __webpack_public_path__ + "static/media/sucess.ecd64836.gif";